import { FastlyImage } from "@components/FastlyImage"

const CustomerMonotoneLogos = (props) => {
  const MonotoneLogo = (customer) => {
    if (!customer.name || !customer.logoMonotone) {
      console.log(`Missing logo for ${customer}`)
      return null
    }

    return (
      <FastlyImage alt={customer.name} src={customer.logoMonotone.file.url} params="?height=55&width=224&fit=bounds" />
    )
  }

  return (
    <div className="block-customermonotonelogos">
      {props.content.customers.map((customer) => {
        return MonotoneLogo(customer)
      })}
    </div>
  )
}

export default CustomerMonotoneLogos
